/**
 * @generated SignedSource<<f9939f115fd427cb8f2baed69bcb35c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreQuery$variables = {};
export type MoreQuery$data = {
  readonly notificationSubscriptions: {
    readonly " $fragmentSpreads": FragmentRefs<"SurveyInvitations_notificationSubscriptions">;
  };
  readonly panelConfiguration: {
    readonly registrationOptions: {
      readonly email: boolean;
      readonly phoneNumber: boolean;
    };
  } | null;
  readonly referralLink: string | null;
  readonly userData: {
    readonly email: string | null;
    readonly phoneNumber: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ChangeEmail_account">;
  } | null;
  readonly walletBalance: {
    readonly " $fragmentSpreads": FragmentRefs<"CancelAccount_walletBalance">;
  } | null;
};
export type MoreQuery = {
  response: MoreQuery$data;
  variables: MoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "RegistrationOptions",
  "kind": "LinkedField",
  "name": "registrationOptions",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v0/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referralLink",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MoreQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CancelAccount_walletBalance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChangeEmail_account"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelConfiguration",
        "kind": "LinkedField",
        "name": "panelConfiguration",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SurveyInvitations_notificationSubscriptions"
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MoreQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formatted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelConfiguration",
        "kind": "LinkedField",
        "name": "panelConfiguration",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyInviteContactChannels",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "c534ce450a36bae84365ca5832f3bb9f",
    "id": null,
    "metadata": {},
    "name": "MoreQuery",
    "operationKind": "query",
    "text": "query MoreQuery {\n  walletBalance {\n    ...CancelAccount_walletBalance\n    id\n  }\n  userData {\n    email\n    phoneNumber\n    ...ChangeEmail_account\n    id\n  }\n  panelConfiguration {\n    registrationOptions {\n      phoneNumber\n      email\n    }\n    id\n  }\n  notificationSubscriptions {\n    ...SurveyInvitations_notificationSubscriptions\n    id\n  }\n  referralLink\n}\n\nfragment CancelAccount_walletBalance on WalletBalance {\n  amount {\n    formatted\n  }\n}\n\nfragment ChangeEmail_account on UserData {\n  email\n  id\n}\n\nfragment SurveyInvitations_notificationSubscriptions on NotificationSubscriptions {\n  id\n  surveyInviteContactChannels\n}\n"
  }
};
})();

(node as any).hash = "f096fd47742d8ec7c6bf00a5d93b0e04";

export default node;
